module.exports = (__parcel__import__("kyp9t")).then(() => parcelRequire('ahP7X'));